/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_3_WInputs */

const en_cp_cmp_3_w = /** @type {(inputs: Cp_Cmp_3_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A verification loop for club teams; Campus Leads may hold both roles; vendor credits still go to the agent of your choice.`)
};

const id_cp_cmp_3_w = /** @type {(inputs: Cp_Cmp_3_WInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loop verifikasi untuk tim klub; Campus Lead boleh merangkap; kredit vendor tetap dipakai di agent pilihan.`)
};

/**
* | output |
* | --- |
* | "A verification loop for club teams; Campus Leads may hold both roles; vendor credits still go to the agent of your choice." |
*
* @param {Cp_Cmp_3_WInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_3_w = /** @type {((inputs?: Cp_Cmp_3_WInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_3_WInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_3_w(inputs)
	return en_cp_cmp_3_w(inputs)
});